import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-d.mydigipostpp.alzp.tgscloud.net',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'fr',
  allowedLanguage: ['fr', 'en'],
  appName: 'MyDigiPost',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'server',
  allowImpersonation: false,
  // Access-code gate shown before the app boots (see app/pin-gate). Never enabled on PROD.
  pinGuardActivated: true,
  recipientGroupsReferentialUrl: '',
};
